import styled from 'styled-components';
import { Button } from 'antd';
import * as palette from '../../styles/variables';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .warning-text {
    font-size: 18px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    span {
      margin-right: 5px;
      &.text-highlighter {
        font-weight: bold;
      }
    }
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  max-width:${props => props.width || '400px'};  
  .ant-input {
    margin-bottom: 12px;
    color: #555555;
    font-size: 16px;
    font-weight: 600;
  }
  .ant-input-suffix {
    top: 21px !important;
  }
  .ant-input:placeholder-shown {
    font-size: 14px;
    font-weight: normal;
  }
  .ant-input:hover,.ant-input:focus {
    border-color: #b9b8b8 !important;
    border-right-width: 1px !important;
    box-shadow:none !important;
  }
  .note {
    font-size: 14px;
    text-transform: initial;
    font-weight: 400;
    color: rgb(151, 150, 150);
    width: 100%;
    text-align: center;
    padding-top: 25px;
    padding-bottom: 35px;
  }
  .info-message{
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .smtp-loader {
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .flows-to-email{
    position:relative;
    color: black;
    .desc{
      margin-top:10px; 
      font-style: italic;   
      font-size: 15px;  
    }
    .ant-checkbox-wrapper{
      color: #314659e6;
      font-size: 15px;
      font-weight: 600;
    }
  }
  .master-template{
    position:relative;
    min-width:395px;
    color: black;
    .btn{
      background: #efeded;
      padding: 8px 10px;
      font-weight: bold;
      cursor:pointer;
      width: fit-content;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      min-width: 200px;
      max-width: 350px;
      margin-top:10px;
      .btn-text {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    .preview-button1 {
      color: #ffffff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      font-size: 14px;
      top: -13px;
      right: -13px;     
    }  
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;    
    }
    
    .circle {
      position: relative;
      background: #835bf6;
      border-radius: 100%;
      height: 25px;
      width: 25px;
    }
    
    .checkMark {
      position: absolute;
      transform: rotate(50deg) translate(-50%, -50%);
      left: 19%;
      top: 39%;
      height: 16px;
      width: 9px;
      border-bottom: 3px solid #fff;
      border-right: 3px solid #fff;
    }
    .desc{
      margin-top:10px; 
      font-style: italic;   
      font-size: 15px;  
    }
  }
`;

export const InputLabel = styled.div`
  color: rgb(49 70 89 / 0.9);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
`;

export const CategoryInputLabel = styled(InputLabel)`
  margin-bottom: 0px;
  width: 70%;
  text-align: left;
`;

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: 10px;
  &.extra-bottom-space {
    margin-bottom: 20px;
  }
  .ant-select {
    width: 100% !important;
    margin-bottom: 12px;
  }
  .ant-select-selection {
    height: 40px;
    .ant-select-selection__rendered {
      height: 100%;
      display: flex;
      align-items: center;
      .ant-select-selection__choice {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
      }
    }
    .ant-select-selection-selected-value {
      font-size: 16px;
      font-weight: 600;
    }
  }
  &.flex-container {
    display: flex;
    align-items: center;
  }
  &.flex-container.space-between {
    justify-content: space-between;

    > ${InputLabel} {
      margin-bottom: 0;
    }

    > button {
      margin-right: 40%;
    }
  }
  &.ai_container {
    display: flex !important;
    transition: height 2s ease-out; */
  }
  &.ai_textArea {
    flex-direction: column;
    height: ${props => props.isAIText ? '120px' : '0'};
    display: ${props => props.isAIText ? 'flex !important' : 'none !important'}; ;
    transition: height 2s ease-out;
  }
  &:last-child {
    width: ${props => (props.tagInput ? '60%' : '')};
  }
  .ant-btn,.ant-btn[disabled] {
    color: #fff !important;
    background: #000 !important;
    border-color: #000;
    width: 45%;
    height: 40px;
    border-radius:20px;
    text-transform: uppercase;
    font-size: 12px;
  }
  .form_btn {
    text-align: center;
    margin: 20px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    .ant-btn,.ant-btn[disabled] {
      width: fit-content;
    }
  }
  .ant-radio-group {
    margin-bottom: 12px;
  }
`;

export const InputFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const AddNewCategory = styled.div`
  top: -7px;
  right: -10px;
  font-size: 12px;
  color: #df4c35;
  font-weight: 600;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  margin-bottom: 10px;
  &:hover {
    cursor: pointer;
  }
`;

export const PopupContainer = styled.div`
  min-width: 240px;
  max-width: 250px;
  padding: 15px;
  position: relative;
  .ant-input {
    margin-bottom: 12px;
    color: #555555;
    font-size: 14px;
    font-weight: 600;
  }
  .ant-input:placeholder-shown {
    font-size: 12px;
    font-weight: normal;
  }
`;

export const PopupActionContainer = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const PopupLabel = styled.div`
  color: rgb(49 70 89 / 0.9);
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 5px;
  width: ${props => props.fillable && '100px'};
`;

export const SaveButton = styled(Button)`
  font-size: 12px;
  height: 30px;
  padding: 8px 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  background: ${props => props.fillable ? '#000' : '#df4c35'};
  border-radius:  ${props => props.fillable ? '25px' : '4px'};
  color: #ffffff;
  border: 2px solid transparent;
  &:hover,
  &:focus {
    background: ${props => props.fillable ? '#000' : '#df4c35'};
    color: #ffffff;
    border-color: transparent;
    box-shadow: initial;
  }
`;

export const CancelButton = styled(Button)`
  font-size: 12px;
  height: 30px;
  padding: 8px 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  background: ${props => props.fillable ? '#000' : '#ffffff'};
  border-radius:  ${props => props.fillable ? '25px' : '4px'};
  color: ${props => props.fillable ? '#fff' : '#555555'};
  border: 1px solid #b1afaf;
  margin-right: 10px;
  &:hover,
  &:focus {
    background: ${props => props.fillable ? '#000' : '#ffffff'};
    color: ${props => props.fillable ? '#fff' : '#555555'};
    border: 1px solid #b1afaf;
    box-shadow: initial;
  }
`;

export const DropdownContainer = styled.div`
  width: 110px;
  margin-right: 23px;
  &.full-width {
    width: 100%;
  }
  .ant-select {
    display: block;
  }
  .ant-select-arrow {
    right: 0px;
    .ant-select-arrow-icon {
      color: rgb(0 0 0 / 0.9);
      font-size: 14px;
      margin-right: 5px;
      &:hover,
      &:focus {
        color: rgb(0 0 0 / 1);
      }
    }
  }
  .ant-select-selection-selected-value {
    font-size: 14px !important;
    font-weight: 600;
    color: rgb(0 0 0 / 0.9);
    &:hover,
    &:focus {
      color: rgb(0 0 0 / 1);
    }
  }
  .ant-select-selection {
    background-color: #fff;
    border: 1px solid rgb(217 217 217 / 1);
    min-width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    &:hover,
    &:focus {
      background-color: #fff;
      border-color: rgb(0 0 0 / 0.9);
    }
  }
  &:last-child {
    margin-right: 0px;
  }
`;

export const WarningLabel = styled.div`
  color: #f5222d;
`;

// *********************

export const TabMenuContainer = styled.div`

.content-wrapper::-webkit-scrollbar{
  display: none;
}
.content-wrapper{
  overflow-y: scroll; 
  height: 480px;
  scrollbar-width: none
}

  display: flex;
  flex-direction: column;
  height: ${props => (props.variableSidebar && '100%')};
  width:${props => (props.complexDesign && '90%')};
  margin:${props => (props.complexDesign && 'auto')};
  .addAttachmentsButton {
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    width: 200px;
    height: 40px;
    text-align: center;
    border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
    color: #000;
    font-weight: 500;
    border-radius: 15px;
    z-index: 10 !important;
    &:hover,
    &:focus {
      border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
      color: #000;
    }
  }
  &.mailSettings {
    width: 100%;
    align-items: ${props => props.addAttachment && 'center'};
    margin-bottom: 0px !important;
    .ant-input {
      min-height: 55%;
      height: 70%;
      font-size: 15px;
    }
  }
  .categoryContainer {
    margin-top: 88px;
    overflow: auto;
    max-height: 48vh;
    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
    @media only screen and (max-width: 1440px) {
      max-height: 45vh;
    }
  }
  &.attachmentTemp {
    align-items: center;
    h2 {
      font-size: 16px !important;
      font-weight: 600;
    }
  }

 .manage-setting-input{
    margin-top: 10px;
    margin-bottom:20px;
    height: 40px
  }
`;

export const TabMenuHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${props => (props.firstElement && '40px')};
`;

export const TabMenuHeader = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${props => (props.inverted ? '#333' : '#fff')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: ${props => (props.subject ? '5px 0 0 0' : props.isImageCount ? '60px 10px 10px 10px' : '10px 10px 10px')};
  text-transform: uppercase;
  text-align: center;
  display: flex;
  justify-content: center;
  position: relative;
  &.categoryName {
    margin: 20px auto;
    &:before {
      content: '';
      display: block;
      width: 65px;
      height: 2px;
      background: #fff;
      left: 25px;
      top: 50%;
      position: absolute;
    }
    &:after {
      content: '';
      display: block;
      width: 65px;
      height: 2px;
      background: #fff;
      right: 25px;
      top: 50%;
      position: absolute;
    }
    h2 {
      font-size: 14px;
      font-weight: 700;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 10px 10px 10px;
      text-transform: capitalize;
      text-align: center;
      max-width: 115px;
      color: ${props => (props.inverted ? '#333' : '#ffffff')};
    }
  }
  .see-all {
    cursor: pointer;
    font-weight: 400;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const TabMenuItemContainer = styled.div`
  display: flex;
  flex-direction: ${props => (props.columnDirection ? 'column' : 'row')};
  flex-wrap: wrap;
  padding-right:0px !important;
  margin-bottom: ${props => (props.subject ? '0' : props.addAttachment ? '100px' : '10px')};
  margin-top: ${props => (props.isSearchView && '80px')};
  position: relative;
  z-index: 101;
  justify-content: ${props=> props.justifyContent ? props.justifyContent : 'center'};
  align-items: ${props => (props.subject ? 'flex-start' : 'center')};
  
  .buttonItem {
    margin: 10px 0 0 10px;
    padding: 5px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    border: 1px solid rgba(14, 19, 24, 0.7);
    width: 70%;
    height: 50px;
    border-radius: 10px;
    
    .overflowText {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .ant-select-selection {
    background-color: #fc6e511c;
    color: #fff;
    border: 1.9px solid hsla(0,0%,100%,0.4);  
    margin: 5px 0;
    font-size: 15px;
    font-weight: 600;
  }
  .ant-select-arrow {
    color: #fff !important;
  }
  .ant-select-selection:hover{
    border:1.5px solid #fff !important; 
  }
  .ant-select-selection:focus, .ant-select-selection:active {
    border-color: #fff;
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: none !important;
  }  
  .ant-select-disabled .ant-select-selection {
    background: #f5f5f5;
    cursor: not-allowed;
    color: #c7c7c7 !important;
    font-weight: 500 !important;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${props => props.top || '150px'};
  .loading-txt {
    font-size: 14px;
    color: #ffffff;
    margin-top: 20px;
  }
`;
export const EmptySettingsDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${props => (props.emptyfolder ? '50px' : '150px')};
  .empty-illustration {
    max-width: 120px;
  }
  .empty-txt {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    max-width: 245px;
    font-size: 14px;
    color: ${props => (props.inverted ? '#333' : '#ffffff')};
    margin-top: 20px;
    span {
      margin-right: 5px;
      text-align: center;
    }
    .empty-links {
      text-decoration: underline;
      color: #2c8fc7;
      font-weight: bold;
      &:hover {
        cursor: pointer;
      }
    }
  }
`;

export const NoDataView = styled.div`
  font-size: ${props => (props.small ? '12px' : '16px')};
  color: white;
  text-align: center;
  margin-top: 35px;
`;

export const TabSearchContainer = styled.div`

  padding: 10px;
  .ant-input-affix-wrapper {
    width: 245px !important;
    height: 40px !important;
    border: 1px solid #293039;
    .ant-input-suffix {
      i {
        padding: 0 5px;
        .anticon-control {
          transform: rotate(90deg);
        }
      }
    }
    .ant-input {
      padding: 0px 65px 0px 45px !important;
      outline: none !important;
      border: none !important;
      &:focus {
        outline: none !important;
        border: none !important;
      }
    }
  }
  i {
    font-size: 16px !important;
    color: black !important;
  }
  .ant-popover {
    left: 175px !important;
  }
  .ant-badge-dot {
    top: 5px !important;
    right: 9px !important;
    background-color: #df4c35;
    color: #df4c35;
  }
  .title{
    padding: 8px 0px !important;
  }
`;

export const PopoverContainer = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  .ant-btn-primary {
    margin-top: 15px;
    background-color: rgb(219 57 31 / 85%);
    color: #ffffff;
    border-radius: 4px;
    border-color: transparent;
    &:hover,
    &:focus {
      background-color: rgb(219 57 31 / 95%);
      color: #ffffff;
      border-color: transparent;
    }
  }
`;

export const NoteText = styled.p`
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  color: white;
`;

export const ClearAll = styled.div`
  position: absolute;
  top: 10px;
  right: 5px;
  font-size: 12px;
  padding: 12px;
  color: #df4c35;
  font-weight: 600;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`;

export const TemplateSingleCard = styled.div`
position: relative;
width: ${props => (props.masterTemplate ? '200px' : '225px')};
height: ${props => (props.inverted ? '370px' : props.masterTemplate ? "323px" : props.isMailTemplates ? '370px' : '400px')};
transition: transform 0.2s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;
.template-media {
  height: 100%;
  position: relative;
  padding: ${props => (props.inverted ? '10px' :  '5px')};
  border-radius: ${props => (props.inverted ? '20px' :  '10px')};
  height: ${props => (props.inverted ? '250px' : props.masterTemplate ? "285px" :'315px')};
  background: #fff !important;
  border: none;
  box-shadow: ${props => (props.inverted ? '0 .1rem 3rem rgba(0,0,0,13%)' : 'none')};
  margin: ${props => (props.inverted ? '20px' : '0')};
}
.template-name {
  font-size:18px;
  color: #ffffff;
  padding: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
  h2 {
    font-family: ambroise-firmin-std, serif;
    color: #ffffff;
    font-size: 18px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre;
    text-align: center;
    max-width: 350px;
  }
}
.image-wrapper {
  height: 100%;
  img {
    max-height: 305px;
    object-fit: contain;
    background: transparent;
    color: transparent;

    &.no-thumbnail {
      height: 100%;
      margin-top: 15%;
      object-fit: ${props => !props.attachmentTemp && 'none'};
    }

    &.no-margin {
      margin-top: 0;
    }
  }

}
.show-loader {
  background-image: url('./generatingPreview.png');
  background-repeat: no-repeat;
  background-position: center;

  img {
    visibility: hidden;
  }
}

.ant-checkbox {
  margin-right: 5px;
}
.ant-checkbox,
.ant-checkbox-inner {
  width: 25px;
  height: 25px;
}
.ant-checkbox-inner {
  border: 2px solid white;
  &::after {
    border-color: black !important;
  }
}
.ant-checkbox .ant-checkbox-inner {
  background-color: white !important;
  border-color: black !important;
}

.preview-button1 {
  background-color: red;
  color: #ffffff;
  width: 22px;
  height: 18px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0px;
  left: 0px;
  font-size: 14px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;    
}

.circle {
  position: relative;
  background: #835bf6;
  border-radius: 100%;
  height: 30px;
  width: 30px;
}

.checkMark {
  position: absolute;
  transform: rotate(50deg) translate(-50%, -50%);
  left: 22%;
  top: 47%;
  height: 19px;
  width: 10px;
  border-bottom: 3px solid #fff;
  border-right: 3px solid #fff;
}
`;

